import { Text, Tooltip } from '@dixa/lib-shared-habla';

import { Score, ScoreIcon, ScoreIconStyle } from 'fable/ScoreIcon';

import { ConversationTimestamp } from '../../conversationTimestamp/conversationTimestamp';

import styles from './satisfactionMessage.module.scss';

type SatisfactionMessageProps = {
  comment: string;
  score: Score;
  ratingStyle: ScoreIconStyle;
  date: string;
  newest?: boolean;
};

export const SatisfactionMessage = ({
  ratingStyle,
  score,
  comment,
  date,
  newest,
}: SatisfactionMessageProps): JSX.Element => (
  <div className={styles.root}>
    <Tooltip content={`${score} out of 5`} wrap="span">
      <ScoreIcon style={ratingStyle} score={score} />
    </Tooltip>

    <div className={styles.content}>
      <Text.Paragraph as="div" variant="3">
        Satisfaction rating received
      </Text.Paragraph>

      <Text.Paragraph as="div" variant="2">
        {comment || 'No comment'}
      </Text.Paragraph>
    </div>

    {!!date && (
      <ConversationTimestamp
        time={date}
        relative={newest}
        shouldDateFormatPersist={!newest}
        textProps={{ className: styles.timestamp }}
      />
    )}
  </div>
);
